export const adminMenu = [
    {
        routeName: 'admin.dashboard',
        name: 'Головна'
    },
    {
        routeName: 'reports',
        name: 'Календар'
    },
    {
        routeName: 'table.reports',
        name: 'Замовлення'
    },
    {
        routeName: 'f-types.index',
        name: 'Види риболовлі без місця'
    },
    {
        routeName: 'maps',
        name: 'Мапа'
    },
    {
        routeName: 'points.index',
        name: 'Місця для рибалки'
    },
    {
        routeName: 'lakes.index',
        name: 'Озера'
    },
    {
        routeName: 'types.index',
        name: 'Тип рибалки'
    },
    {
        routeName: 'categories.index',
        name: 'Тарифи'
    },
    {
        routeName: 'messages.index',
        name: 'Шаблони смс'
    },
    {
        routeName: 'blocks.index',
        name: 'Блокування рибалки'
    },
    {
        routeName: 'users.index',
        name: 'Користувачі'
    },
    {
        routeName: 'attributes.index',
        name: 'Атрибути'
    },
    {
        routeName: 'rules.index',
        name: 'Правила сервісу'
    },
    {
        routeName: 'bonus-rules.index',
        name: 'Бонус балансу'
    },
    {
        routeName: 'products.index',
        name: 'Продукти'
    },
    {
        routeName: 'product-orders.index',
        name: 'Замовлення товарів'
    },
    {
        routeName: 'subscription-config.index',
        name: 'Налаштування підписки'
    },
];
export const mainMenu = [
    {
        routeName: 'index',
        name: 'Головна'
    },
    {
        routeName: 'index.rules',
        name: 'Правила'
    },
    {
        routeName: 'index.about',
        name: 'Про нас'
    },
    {
        routeName: 'index.publicOffer',
        name: 'Публічна оферта'
    },
    {
        routeName: 'index.deliveryPayment',
        name: 'Доставка і оплата'
    },
    {
        routeName: 'products.list',
        name: 'Продукти'
    },
    {
        routeName: 'cabinet.index',
        name: 'Кабінет'
    },
];
